type WindowWithDataLayer = Window & {
  dataLayer: Record<string, unknown>[];
};

declare const window: WindowWithDataLayer;

const GTM_EVENTS = {
  SIGNUP: 'signup',
  SUBSCRIPTION_PURCHASE: 'subscription_purchase'
};

export const GoogleTagManagerService = {
  sendSignupEvent: () => {
    window.dataLayer.push({
      event: GTM_EVENTS.SIGNUP
    });
  },

  sendSubscriptionPurchaseEvent: (totalAmount: number, currency: 'usd', customerLtvAvg: number) => {
    window.dataLayer.push({
      event: GTM_EVENTS.SUBSCRIPTION_PURCHASE,
      value: totalAmount,
      currency: currency.toUpperCase(), // Needs to be uppercase and following ISO 4217
      predicted_ltv: customerLtvAvg
    });
  }
};
